import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-710bc6af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-select" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "required"
}
const _hoisted_4 = ["name", "id", "value", "disabled"]
const _hoisted_5 = {
  key: 0,
  value: ""
}
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: $props.name
        }, [
          _createElementVNode("span", null, _toDisplayString($props.label), 1 /* TEXT */),
          ($props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["Field"], {
      name: $props.name,
      type: "text",
      modelValue: $setup.inputValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputValue) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["select-wrapper", { disabled: $props.disabled }])
        }, [
          _createElementVNode("select", {
            class: _normalizeClass({ placeholder: !$props.value }),
            name: $props.name,
            id: $props.name,
            value: $props.value,
            disabled: $props.disabled,
            onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.onChangeSelect($event)))
          }, [
            ($props.placeholder)
              ? (_openBlock(), _createElementBlock("option", _hoisted_5, _toDisplayString($props.placeholder), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.options, (option, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: $setup.optionValue(option),
                key: index
              }, _toDisplayString($setup.optionText(option)), 9 /* TEXT, PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */))
          ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_4),
          _createVNode($setup["InlineSvg"], {
            class: "down-arrow-icon",
            src: require('@/assets/icons/chevron-down.svg'),
            alt: "아래 화살표"
          }, null, 8 /* PROPS */, ["src"])
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["name", "modelValue"])
  ]))
}